module.exports = __webpack_public_path__ + "img/empty-bg.1e3b46e0.png";